import type { ReactNode } from "@tanstack/react-router";

import Input from "@/components/Input/Input";
import { HStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";

import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value?: number;
  onChange: (value?: number) => void;
  inputClassName?: string;
  isInt?: boolean;
  allowNegative?: boolean;
  // oxlint-disable-next-line typescript/no-redundant-type-constituents -- ReactNode includes any
  unit?: string | ReactNode;
};

/**
 * Card-based Form / NumberItem
 */
export const CFormNumberItem = buildCFormItem((props: Props) => {
  return (
    <CFormItemBase
      {...props}
      readComponent={
        <HStack className="gap-2 items-baseline">
          {props.value}
          {typeof props.unit === "string" ? (
            <Text variant="labelReg">{props.unit}</Text>
          ) : (
            props.unit
          )}
        </HStack>
      }
      writeComponent={
        <HStack className="gap-2 items-center">
          <Input
            type="number"
            inputMode="numeric"
            pattern={props.isInt ? "[0-9]*" : undefined}
            min={props.allowNegative ? undefined : 0}
            step={props.isInt ? 1 : undefined}
            value={props.value ?? ""}
            onChange={(e) => {
              const value =
                e.target.value === ""
                  ? undefined
                  : props.isInt
                    ? parseInt(e.target.value, 10)
                    : parseFloat(e.target.value);
              props.onChange(value);
            }}
            className={props.inputClassName ?? "w-[100px]"}
            disabled={props.readonly}
          />
          {typeof props.unit === "string" ? (
            <Text variant="labelReg">{props.unit}</Text>
          ) : (
            props.unit
          )}
        </HStack>
      }
    />
  );
});
